export default "__VITE_ASSET__OAAipLNz__"